import '../tw.css';
import { useTranslation } from "react-i18next";
import ImgCenteredCaption from '../Components/ImgCenteredCaption';
import Card from '../Components/Card';
import { MapIcon, TimeIcon } from '../Components/Icons';
import { Page } from '../Const/Page';
import { GetBodyFontClass, GetHeaderFontClass, GotoTop, GotoTopOnAnchor } from '../Helper/Helper';
import { useHistory } from 'react-router-dom';

export default function MandarinStudentFellowshipPage(){
    const history = useHistory();
    const { t } = useTranslation("studentMinistry");
    return <div className='mb-10'>
        <ImgCenteredCaption imageSrc={"https://lccccompany.blob.core.windows.net/public/shine.jpg"} alt="Church Building">
            <h1 className={`md:text-6xl text-2xl text-center text-white ${GetHeaderFontClass()}`}>{t('msf.title')}</h1>
            {/* <p className={`md:text-2xl text-lg text-center text-white mt-5 ${GetBodyFontClass()}`}>{t('msf.subTitle')}</p> */}
        </ImgCenteredCaption>
        <div className='flex justify-center mt-5 mx-3 md:mx-10'>
            <Card>
                <h2 className={`text-center font-bold ${GetHeaderFontClass()}`}>{t(`msf.title`)}</h2>
                <h3 className={`text-center mt-3 ${GetBodyFontClass()}`}>{t(`msf.subtitle`)}</h3>
                <p className={`text-center mt-3 ${GetBodyFontClass()}`}><TimeIcon/>{t(`msf.time`)}</p>
                <p className={`text-center mt-3 ${GetBodyFontClass()}`}><MapIcon/>{t(`msf.venue`)}</p>
                <a className={`cursor-pointer text-right decoration-solid underline decoration-1 text-blue-500 ${GetBodyFontClass()}`} onClick={(e)=>{history.push(Page.studentMinistry);GotoTopOnAnchor(e)}}>{t(`msf.notsuitable`)}</a>
            </Card>
        </div>
        <div className='flex justify-center mt-5 mx-3 md:mx-10'>
            <Card classNames='max-w-xl'>
                <img src='https://lccccompany.blob.core.windows.net/public/shine_schedule.jpg' ></img>
            </Card>
        </div>
    </div>
}
